module.exports = __webpack_public_path__ + "img/cww_10.76ae9f05.jpg";